import { QueryResult, useQuery } from "@apollo/client";

import { graphql } from "../generated/gql/gql";
import { MeQuery } from "../generated/gql/graphql";

export type User = MeQuery["me"];

const GET_ME_OPTIONS = graphql(`
  query Me {
    me {
      name
      activeClient {
        logoUrl
        canUseShadowsAndReflections
        canAdaptLabel
        defaultAspectRatio
      }
    }
  }
`);

export default function useUser(): QueryResult<MeQuery, Record<string, never>> {
  return useQuery(GET_ME_OPTIONS);
}
